export default __webpack_public_path__ + "static/brand-colors-dark-80ac2e11f3f38baba5d8b188564aa51805f33ede5be24ffd00273f04e719e92b.png";